export const ANALYTICS_REQUEST : string = 'ANALYTICS_REQUEST'
export const ANALYTICS_SUCCESS : string = 'ANALYTICS_SUCCESS'
export const ANALYTICS_FAIL : string = 'ANALYTICS_FAIL'
